import { compose } from 'redux'

// higher-order components
import withRedux from './withRedux'
import withEventHandlers from './withEventHandlers'
import withMediaQuery from './withMediaQuery'

// presentational component
import UI from './UI'

export default compose(
  withRedux, // provides form data, sets error state
  withEventHandlers, // for handling location change
  withMediaQuery // for detection of xs or smaller display
)(UI)
